import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.toTop();
        this.viewMore();
        this.sideNav();

        //intro
        document.body.setAttribute("data-ready", "1");
    }

    toTop() {
        const trigger = document.querySelector(".js-pageup");

        trigger.addEventListener("click", (e) => {
            gsap.to(window, { duration: 0.8, scrollTo: { y: 0 }, ease: "expo.inOut" });
        });
    }

    viewMore() {
        const trigger = [...document.querySelectorAll(".js-songlistmore")];

        trigger.forEach((item) => {
            item.addEventListener("click", () => {
                item.setAttribute("data-disable", 1);
                item.previousElementSibling.setAttribute("data-open", 1);
            });
        });
    }

    sideNav() {
        let open = false;
        const trigger = document.querySelector(".js-sidenavtrigger");
        const wrapper = document.querySelector(".js-sidenav");

        if (!trigger && !wrapper) {
            return;
        }

        trigger.addEventListener("click", () => {
            if (!open) {
                const innerHeight = wrapper.querySelector(".l-sidenav__list").offsetHeight;
                wrapper.style.height = `${innerHeight}px`;
                open = true;
            } else {
                wrapper.style.height = "0";
                open = false;
            }
        });
    }
}
